;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        payment_gateways: {
            type: Object,
            required: true,
            default: []
        }
    },
    data: function data() {
        return {
            search_text: "",
            search_result: []
        };
    },
    mounted: function mounted() {
        document.querySelector("#search-modal").addEventListener("click", this.handleClickOutside);
    },

    methods: {
        handleClickOutside: function handleClickOutside(event) {
            if (!this.$refs.search_div.contains(event.target)) {
                this.$emit("hide-search-modal");
            }
        },
        showBank: function showBank(gateway) {
            this.$emit("show-bank", gateway);
        }
    },
    computed: {},
    watch: {
        search_text: function search_text(newValue, _oldValue) {

            if (newValue === "") {
                this.search_result = [];
            } else {
                var gateways = this.payment_gateways.filter(function (gateway) {
                    return gateway.gateway_type === "bank";
                });
                this.search_result = gateways.filter(function (gateway) {
                    return gateway.common_name.toLowerCase().includes(newValue.toLowerCase());
                });
            }
        }
    }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative z-10",attrs:{"aria-labelledby":"modal-title","id":"search-modal"}},[_c('div',{staticClass:"fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"}),_vm._v(" "),_c('div',{staticClass:"fixed inset-0 z-10 w-screen overflow-y-auto"},[_c('div',{staticClass:"flex min-h-full items-start justify-center p-4 text-center mt-24 sm:p-0"},[_c('div',{ref:"search_div",staticClass:"relative transform overflow-hidden rounded-[35px] bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-[691px]",attrs:{"id":"search-div"}},[_c('div',{staticClass:"border-b border-b-[#C7C7C7] px-4 sm:px-8 py-5"},[_c('div',{staticClass:"relative flex items-center",attrs:{"x-data":"{searchText: ''}"}},[_c('svg',{attrs:{"width":"21","height":"20","viewBox":"0 0 21 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M19.125 18.375L15.7709 15.0208M18.1667 9.27083C18.1667 13.7697 14.5197 17.4167 10.0208 17.4167C5.52201 17.4167 1.875 13.7697 1.875 9.27083C1.875 4.77201 5.52201 1.125 10.0208 1.125C14.5197 1.125 18.1667 4.77201 18.1667 9.27083Z","stroke":"#3B4856","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search_text),expression:"search_text"}],staticClass:"block w-full rounded-md border-0 focus:border-transparent focus:ring-transparent text-gray-900 placeholder:text-gray-400 sm:text-sm sm:leading-6",attrs:{"type":"text","id":"search","placeholder":"Search","aria-describedby":"search","x-model":"searchText"},domProps:{"value":(_vm.search_text)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search_text=$event.target.value}}}),_vm._v(" "),_c('div',{attrs:{"x-show":"searchText"}},[_c('button',{on:{"click":function($event){_vm.search_text = ''}}},[_c('svg',{attrs:{"width":"32","height":"33","viewBox":"0 0 32 33","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('rect',{attrs:{"y":"0.25","width":"32","height":"32","rx":"16","fill":"#EEEEEE"}}),_vm._v(" "),_c('path',{attrs:{"d":"M10 22.25L22 10.25M10 10.25L22 22.25","stroke":"black","stroke-width":"2.5","stroke-linecap":"round","stroke-linejoin":"round"}})])])])])]),_vm._v(" "),_c('div',{staticClass:"px-4 sm:px-8 py-5 sm:py-8"},_vm._l((_vm.search_result),function(gateway){return _c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.showBank(gateway)}}},[_c('p',{staticClass:"py-3"},[_vm._v(_vm._s(gateway.common_name))])])}),0)])])])])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-aff351d0", __vue__options__)
  } else {
    hotAPI.reload("data-v-aff351d0", __vue__options__)
  }
})()}